<page-load-header *ngIf="!initialized"></page-load-header>

<div *ngIf="initialized" class="cs_wrapper">
      <div *ngIf="!isShared" class="row">
        <div class="col-lg-12 mt-1 mb-2">
          <div class="float-right d-none d-lg-block">
            <a href="javascript:void(0)" (click)="onCopyLink()" class="btn btn-sm btn-primary ml-2"> Shareable Link </a>
          </div>
        </div>
      </div>
      <table>
        <thead>
          <tr>
            <td>
              <div class="cs_header">
                <div class="cs_list">
                  <div class="cs_list-item">
                    <span class="cs_hl">Name:</span> {{analysis.user.firstName}} {{analysis.user.lastName}}
                  </div>
                  <div class="cs_list-item">
                    <span class="cs_hl">Date:</span> {{analysis.reportDate | date:'short' }}
                  </div>
                </div>
               <a href="https://rundna.com/" target="_blank"> <img class="cs_logo" src="../../../../assets/img/runningreport/logo.png" alt="logo" /></a>
              </div>
            </td>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              <!-- page 1 -->
              <div class="card card-body">
                <div class="cs_panel">
                  <div class="cs_sec-header">
                    <div class="cs_sec-left overal">
                      <div class="header-with-icon">
                        <div class="header-text">
                          <h2>RunDNA</h2>
                          <h2>Running Score</h2>
                        </div>

                        <div class="help-icon" kendoTooltip (click)="openHelpArticle()" title="Help">
                          <i class="fas fa-info-circle"></i>
                        </div>
                      </div>
                      <div class="cs_scrore_overal_container">
                        <div class="cs_scrore_overal_item_label cs_scrore_overal_item_label_position_{{ analysis.runningAnalysisReportScoreDescription }}">&#9664; {{analysis.runningScore}}</div>
                        <div *ngIf="analysis.protocolId != '2026.0'" class="cs_score cs_scrore_overal_item colorg-1"></div>
                        <div *ngIf="analysis.protocolId != '2026.0'" class="cs_score cs_scrore_overal_item colorg-2"></div>
                        <div *ngIf="analysis.protocolId != '2026.0'" class="cs_score cs_scrore_overal_item colorg-3"></div>
                        <div *ngIf="analysis.protocolId != '2026.0'" class="cs_score cs_scrore_overal_item colorg-4"></div>
                        <div *ngIf="analysis.protocolId == '2026.0'" class="cs_score cs_scrore_overal_item colorg-5"></div>
                        <div *ngIf="analysis.protocolId == '2026.0'" class="cs_score cs_scrore_overal_item colorg-6"></div>
                        <div *ngIf="analysis.protocolId == '2026.0'" class="cs_score cs_scrore_overal_item colorg-7"></div>
                        <div *ngIf="analysis.protocolId == '2026.0'" class="cs_score cs_scrore_overal_item colorg-8"></div>
                      </div>
                    </div>
                    <div class="cs_sec-right ">
                      <div class="gait_score_descr">
                        {{analysis.runningAnalysisReportScoreDescription | enumString: runningAnalysisReportScoreDescriptionEnum}}
                      </div>
                      <div style="display: flex; margin-top:0.6em;">
                        <div class="watch-video">
                          <a href="javascript:void(0)" (click)="showVideo()" role="button" aria-label="Play video" class="watch-link">
                            <img src="assets/img/assessment/3d_capture_thumbnail.PNG" alt="Watch Video" class="watch-thumb">
                            <span class="play-btn" aria-hidden="true">
                              <!-- SVG triangle for crispness -->
                              <svg viewBox="0 0 24 24" class="play-icon" focusable="false" aria-hidden="true">
                                <path d="M8 5v14l11-7z"></path>
                              </svg>
                            </span>
                          </a>
                        </div>
                        <div class="speed-lable" style=""> <h3> Gait Speed </h3> <div style="margin-left: 0.5em;">{{analysis.speed | number:'1.2-2' }} {{analysis.speedUnit | enumString: speedUnitEnum}} </div></div>
                      </div>
                    </div>

                  </div>

                  <div class="cs_stats-wrapper cs_gap cs_mt2">
                    <img src="../../../../assets/img/runningreport/human.png" alt="image" class="cs_image_001" />

                    <!--  -->
                    <div class="cs_stats-row">
                      <div class="cs_stats-col">
                        <h3>
                          General Form
                        </h3>
                      </div>
                      <div class="cs_stats-col to-center">
                        <div class="cs_stats-col-label text-underline">Left</div>
                        <div class="cs_score s-{{ analysis.generalForm.left | enumString: categoryScoreEnum | lowercase }}">{{analysis.generalForm.left | enumString: categoryScoreEnum}}</div>
                      </div>
                      <div class="cs_stats-col"></div>
                      <div class="cs_stats-col to-center">
                        <div class="cs_stats-col-label text-underline">Right</div>
                        <div class="cs_score s-{{ analysis.generalForm.right | enumString: categoryScoreEnum | lowercase }}">{{analysis.generalForm.right | enumString: categoryScoreEnum}}</div>
                      </div>
                      <div class="cs_stats-col"></div>
                    </div>
                    <!--  -->
                    <div class="cs_separator"></div>
                    <div class="cs_stats-row">
                      <div class="cs_stats-col">
                        <h3>Pelvis</h3>
                      </div>
                      <div class="cs_stats-col to-center">
                        <div class="cs_score s-{{ analysis.pelvis.left | enumString: categoryScoreEnum | lowercase }}">{{analysis.pelvis.left | enumString: categoryScoreEnum}}</div>
                      </div>
                      <div class="cs_stats-col"></div>
                      <div class="cs_stats-col to-center">
                        <div class="cs_score s-{{ analysis.pelvis.right | enumString: categoryScoreEnum | lowercase }}">{{analysis.pelvis.right | enumString: categoryScoreEnum}}</div>
                      </div>
                      <div class="cs_stats-col"></div>
                    </div>
                    <!--  -->
                    <div class="cs_separator"></div>
                    <div class="cs_stats-row">
                      <div class="cs_stats-col">
                        <h3>Hips</h3>
                      </div>
                      <div class="cs_stats-col to-center">
                        <div class="cs_score s-{{ analysis.hip.left | enumString: categoryScoreEnum | lowercase }}">{{analysis.hip.left | enumString: categoryScoreEnum}}</div>
                      </div>
                      <div class="cs_stats-col"></div>
                      <div class="cs_stats-col to-center">
                        <div class="cs_score s-{{ analysis.hip.right | enumString: categoryScoreEnum | lowercase }}">{{analysis.hip.right | enumString: categoryScoreEnum}}</div>
                      </div>
                      <div class="cs_stats-col"></div>
                    </div>
                    <!--  -->
                    <div class="cs_separator"></div>
                    <div class="cs_stats-row">
                      <div class="cs_stats-col">
                        <h3>Knees</h3>
                      </div>
                      <div class="cs_stats-col to-center">
                        <div class="cs_score s-{{ analysis.knee.left | enumString: categoryScoreEnum | lowercase }}">{{analysis.knee.left | enumString: categoryScoreEnum}}</div>
                      </div>
                      <div class="cs_stats-col"></div>
                      <div class="cs_stats-col to-center">
                        <div class="cs_score s-{{ analysis.knee.right | enumString: categoryScoreEnum | lowercase }}">{{analysis.knee.right | enumString: categoryScoreEnum}}</div>
                      </div>
                      <div class="cs_stats-col"></div>
                    </div>
                    <!--  -->
                    <div class="cs_separator"></div>
                    <div class="cs_stats-row">
                      <div class="cs_stats-col">
                        <h3>Ankle</h3>
                      </div>
                      <div class="cs_stats-col to-center">
                        <div class="cs_score s-{{ analysis.foot.left | enumString: categoryScoreEnum | lowercase }}">{{analysis.foot.left | enumString: categoryScoreEnum}}</div>
                      </div>
                      <div class="cs_stats-col"></div>
                      <div class="cs_stats-col to-center">
                        <div class="cs_score s-{{ analysis.foot.right | enumString: categoryScoreEnum | lowercase }}">{{analysis.foot.right | enumString: categoryScoreEnum}}</div>
                      </div>
                      <div class="cs_stats-col"></div>
                    </div>
                  </div>
                </div>
                <div class="cs_panel cs_mt1">

                  <h3 style="color:gray; text-align:center;">GENERAL PARAMETERS</h3>
                  <div class="cs_stats-wrapper cs_gap-sm ">

                    <div class="cs_stats-row cs_around">
                      <div class="cs_stats-col cs_inline">
                        <h4>Cadence</h4>
                        <span>{{analysis.cadence.value | number:'1.0-0'}} spm</span>
                        <div class="cs_score sm s-{{ analysis.cadence.score | enumString: categoryScoreEnum | lowercase }}">{{analysis.cadence.score | enumString: categoryScoreEnum}}</div>
                      </div>
                      <div class="cs_stats-col cs_inline">
                        <h4> </h4>
                        <span></span>
                        <div class="cs_score sm"></div>
                      </div>
                      <div class="cs_stats-col cs_inline">
                        <h4>Vertical Oscillation</h4>
                        <span>{{analysis.verticalOscillation.value  | number:'1.0-0'}} cm</span>
                        <div class="cs_score sm s-{{ analysis.verticalOscillation.score | enumString: categoryScoreEnum | lowercase }}">{{analysis.verticalOscillation.score | enumString: categoryScoreEnum}}</div>
                      </div>
                    </div>

                    <div class="cs_separator"></div>

                    <div class="cs_stats-row">
                      <div class="cs_stats-col"></div>
                      <div class="cs_stats-col to-center text-underline">Left</div>
                      <div class="cs_stats-col"></div>
                      <div class="cs_stats-col to-center text-underline">Right</div>
                      <div class="cs_stats-col"></div>
                    </div>
                    <div class="cs_stats-row">
                      <div class="cs_stats-col">
                        <div class="cs_stats-value">{{analysis.groundContact.left| number:'1.0-0'}} ms</div>
                      </div>
                      <div class="cs_stats-col to-center">
                        <div class="cs_score sm s-{{ analysis.groundContact.leftScore | enumString: categoryScoreEnum | lowercase }}">{{analysis.groundContact.leftScore | enumString: categoryScoreEnum}}</div>
                      </div>
                      <div class="cs_stats-col to-center">
                        <h4>Ground Contact Time</h4>
                      </div>
                      <div class="cs_stats-col to-center">
                        <div class="cs_score sm s-{{ analysis.groundContact.rightScore | enumString: categoryScoreEnum | lowercase }}">{{analysis.groundContact.rightScore | enumString: categoryScoreEnum}}</div>
                      </div>
                      <div class="cs_stats-col">{{analysis.groundContact.right| number:'1.0-0'}} ms</div>
                    </div>
                    <div class="cs_stats-row">
                      <div class="cs_stats-col">
                        <div class="cs_stats-value">{{analysis.frontSideStance.left| number:'1.0-0'}} %</div>
                      </div>
                      <div class="cs_stats-col to-center">
                        <div class="cs_score sm s-{{ analysis.frontSideStance.leftScore | enumString: categoryScoreEnum | lowercase }}">{{analysis.frontSideStance.leftScore | enumString: categoryScoreEnum}}</div>
                      </div>
                      <div class="cs_stats-col to-center">
                        <h4>Front Side Stance</h4>
                      </div>
                      <div class="cs_stats-col to-center">
                        <div class="cs_score sm s-{{ analysis.frontSideStance.rightScore | enumString: categoryScoreEnum | lowercase }}">{{analysis.frontSideStance.rightScore | enumString: categoryScoreEnum}}</div>
                      </div>
                      <div class="cs_stats-col">{{analysis.frontSideStance.right| number:'1.0-0'}} %</div>
                    </div>
                    <div class="cs_stats-row">
                      <div class="cs_stats-col">
                        <div class="cs_stats-value">{{analysis.dutyFactor.left| number:'1.0-0'}} %</div>
                      </div>
                      <div class="cs_stats-col to-center">
                        <div class="cs_score sm s-{{ analysis.dutyFactor.leftScore | enumString: categoryScoreEnum | lowercase }}">{{analysis.dutyFactor.leftScore | enumString: categoryScoreEnum}}</div>
                      </div>
                      <div class="cs_stats-col to-center">
                        <h4>Duty Factor</h4>
                      </div>
                      <div class="cs_stats-col to-center">
                        <div class="cs_score sm s-{{ analysis.dutyFactor.rightScore | enumString: categoryScoreEnum | lowercase }}">{{analysis.dutyFactor.rightScore | enumString: categoryScoreEnum}}</div>
                      </div>
                      <div class="cs_stats-col">{{analysis.dutyFactor.right| number:'1.0-0'}} %</div>
                    </div>
                    <div class="cs_stats-row">
                      <div class="cs_stats-col">
                        <div class="cs_stats-value">{{analysis.legStiffness.left| number:'1.0-2'}} kN/m</div>
                      </div>
                      <div class="cs_stats-col to-center">
                        <div class="cs_score sm s-{{ analysis.legStiffness.leftScore | enumString: categoryScoreEnum | lowercase }}">{{analysis.legStiffness.leftScore | enumString: categoryScoreEnum}}</div>
                      </div>
                      <div class="cs_stats-col to-center">
                        <h4>Leg Stiffness</h4>
                      </div>
                      <div class="cs_stats-col to-center">
                        <div class="cs_score sm s-{{ analysis.legStiffness.rightScore | enumString: categoryScoreEnum | lowercase }}">{{analysis.legStiffness.rightScore | enumString: categoryScoreEnum}}</div>
                      </div>
                      <div class="cs_stats-col">{{analysis.legStiffness.right| number:'1.0-2'}} kN/m</div>
                    </div>
                  </div>
                </div>

                <div class="cs_sec-header dark cs_mt1">
                  <div class="cs_sec-left">
                    <h2>Runner Category</h2>
                    <div class="cs_highlight" title="{{analysis.categoryRaw}}">
                      {{ (analysis.categoryRaw.length>25) ? (analysis.categoryRaw | slice:0:24) + '...' : (analysis.categoryRaw) }}
                    </div>
                  </div>
                  <div class="cs_sec-right">
                    {{ analysis.categoryText }}
                  </div>
                </div>

                <div class="cs_sec-header dark cs_mt1">
                  <div class="cs_sec-left">
                    <h2>Primary Factor</h2>
                    <div class="cs_highlight" title="{{analysis.primaryFactorRaw}}">
                      {{ (analysis.primaryFactorRaw.length>25) ? (analysis.primaryFactorRaw | slice:0:24) + '...' : (analysis.primaryFactorRaw) }}
                    </div>
                  </div>
                  <div class="cs_sec-right">
                    {{analysis.primaryFactorText}}
                  </div>
                </div>

                <div class="cs_notes cs_mt1">
                  <div class="cs_notes-label">Notes:</div>
                  <div *ngIf="analysis.notes" class="cs_notes-content" title="{{analysis.notes}}">

                    {{ (analysis.notes.length>330) ? (analysis.notes | slice:0:330) + '...' : (analysis.notes) }}
                  </div>
                </div>

                <div *ngIf="analysis.protocolId != '2026.0'" class="cs_score-tab cs_mt1 score_descr">
                  <div class="cs_score-tab-item">
                    <div class="cs_score-tab-item-label">
                      Good
                    </div>
                    <div class="cs_score-tab-item-review">
                      <div class="cs_score  s-g">g</div>
                      <div class="cs_score  s-gf">gf</div>
                    </div>
                  </div>
                  <div class="cs_score-tab-item">
                    <div class="cs_score-tab-item-label">
                      Fair
                    </div>
                    <div class="cs_score-tab-item-review">
                      <div class="cs_score  s-fg">fg</div>
                      <div class="cs_score  s-f">f</div>
                      <div class="cs_score  s-fp">fp</div>
                    </div>
                  </div>
                  <div class="cs_score-tab-item">
                    <div class="cs_score-tab-item-label">
                      Poor
                    </div>
                    <div class="cs_score-tab-item-review">
                      <div class="cs_score  s-pf">pf</div>
                      <div class="cs_score  s-p">p</div>
                    </div>
                  </div>
                </div>

                <div *ngIf="analysis.protocolId == '2026.0'" class="cs_score-tab cs_mt1 score_descr">
                  <div class="cs_score-tab-item">
                    <div class="cs_score-tab-item-label">
                      Excellent
                    </div>
                    <div class="cs_score-tab-item-review">
                      <div class="cs_score s-e">e</div>
                    </div>
                  </div>
                  <div class="cs_score-tab-item">
                    <div class="cs_score-tab-item-label">
                      Good
                    </div>
                    <div class="cs_score-tab-item-review">
                      <div class="cs_score  s-g">g</div>
                    </div>
                  </div>
                  <div class="cs_score-tab-item">
                    <div class="cs_score-tab-item-label">
                      Fair
                    </div>
                    <div class="cs_score-tab-item-review">
                      <div class="cs_score  s-f">f</div>
                    </div>
                  </div>
                  <div class="cs_score-tab-item">
                    <div class="cs_score-tab-item-label">
                      Poor
                    </div>
                    <div class="cs_score-tab-item-review">
                      <div class="cs_score  s-p">p</div>
                    </div>
                  </div>
                </div>
              </div>


              <hr class="cs_page-break" />
              <!-- page 2 -->
              <div class="card card-body">
                <div class="cs_short-box cs_mt2">
                  <h1 class="text-center">Scoring Factors</h1>
                  <p class="text-center">Below you will find the individual factors that contribute to your RunDNA Running Score.</p>
                </div>

                <h3 class="text-center factor_section">GENERAL PARAMETERS</h3>
                <div class="cs_separator_gray"></div>

                <div class="cs_pbar-wrapper">
                  <div class="cs_pbar-item">
                    <div class="cs_pbar-val">
                      <h3 class="cs_pbar-lable">Cadence</h3>
                    </div>
                    <div class="cs_pbar-line" style="background: {{generateLinearGradient(140, 210, analysis.cadence.avgValue, analysis.cadence.stDevValue)}}">
                      <div class="cs_bpar-mark cs-ml pos-1">
                      </div>
                      <div class="cs_bpar-mark cs-mr" style="left:{{getGradientPosition(140, 210, analysis.cadence.avgValue, analysis.cadence.stDevValue, analysis.cadence.deviationPoints)}}%">
                        <span> {{analysis.cadence.rawValue}} </span>
                        <span>&#9650;</span>
                      </div>
                      <div class="cs_bpar-mark cs-ml text-sm cs_min_gradient_label">140</div>
                      <div class="cs_bpar-mark cs-ml text-sm cs_max_gradient_label">210</div>
                    </div>
                  </div>
                  <p class="cs_pbar_description">
                    Cadence is the number of steps per minute you take measured in steps per minute (spm). There is no ideal cadence, but slower cadences have been linked to certain injuries.
                  </p>
                </div>
                <!--  -->
                <div class="cs_pbar-wrapper">
                  <div class="cs_pbar-item">
                    <div class="cs_pbar-val">
                      <h3 class="cs_pbar-lable">Vertical Oscillation</h3>
                    </div>
                    <div class="cs_pbar-line" style="background: {{generateLinearGradient(4, 15, analysis.verticalOscillation.avgValue, analysis.verticalOscillation.stDevValue)}}">
                      <div class="cs_bpar-mark cs-ml pos-1">
                      </div>
                      <div class="cs_bpar-mark cs-mr" style="left:{{getGradientPosition(4, 15, analysis.verticalOscillation.avgValue, analysis.verticalOscillation.stDevValue, analysis.verticalOscillation.deviationPoints)}}%">
                        <span> {{analysis.verticalOscillation.rawValue}} </span>
                        <span>&#9650;</span>
                      </div>
                      <div class="cs_bpar-mark cs-ml text-sm cs_min_gradient_label">4</div>
                      <div class="cs_bpar-mark cs-ml text-sm cs_max_gradient_label">15</div>
                    </div>
                  </div>
                  <p class="cs_pbar_description">
                    Vertical oscillation is the amount of motion spent going up and down measured in centimeters (cm). Focusing your energy on running forward rather than up and down helps with injuries and performance.
                  </p>
                </div>
                <!--  -->
                <div class="cs_pbar-wrapper ">
                  <div class="cs_pbar-item">
                    <div class="cs_pbar-val">
                      <h3 class="cs_pbar-lable cs_label-to-center">
                        Ground Contact Time
                      </h3>
                    </div>
                    <div class="cs_pbar-line" style="background: {{generateLinearGradient(100, 350, analysis.groundContact.avgValue, analysis.groundContact.stDevValue)}}">
                      <div class="cs_bpar-mark cs-ml" style="left:{{getGradientPosition(100, 350, analysis.groundContact.avgValue, analysis.groundContact.stDevValue, analysis.groundContact.deviationPointsLeft)}}%">
                        <span>{{analysis.groundContact.rawValueLeft}}</span>
                        <span>L</span>
                      </div>
                      <div class="cs_bpar-mark cs-mr" style="left:{{getGradientPosition(100, 350, analysis.groundContact.avgValue, analysis.groundContact.stDevValue, analysis.groundContact.deviationPointsRight)}}%">
                        <span>{{analysis.groundContact.rawValueRight}}</span>
                        <span>R</span>
                      </div>
                      <div class="cs_bpar-mark cs-ml text-sm cs_min_gradient_label">100</div>
                      <div class="cs_bpar-mark cs-ml text-sm cs_max_gradient_label">350</div>
                    </div>
                  </div>
                  <p class="cs_pbar_description">
                    Ground contact time is the time spent with your foot on the ground measured in milliseconds (ms). Minimizing the time spent on the ground helps with decreasing injuries and improving performance.
                  </p>
                </div>
                <!--  -->
                <div class="cs_pbar-wrapper ">
                  <div class="cs_pbar-item">
                    <div class="cs_pbar-val">
                      <h3 class="cs_pbar-lable">
                        Front Side Stance
                      </h3>
                    </div>
                    <div class="cs_pbar-line" style="background: {{generateLinearGradient(10, 60, analysis.frontSideStance.avgValue, analysis.frontSideStance.stDevValue)}}">
                      <div class="cs_bpar-mark cs-ml" style="left:{{getGradientPosition(10, 60, analysis.frontSideStance.avgValue, analysis.frontSideStance.stDevValue, analysis.frontSideStance.deviationPointsLeft)}}%">
                        <span>{{analysis.frontSideStance.rawValueLeft}}</span>
                        <span>L</span>
                      </div>
                      <div class="cs_bpar-mark cs-mr" style="left:{{getGradientPosition(10, 60, analysis.frontSideStance.avgValue, analysis.frontSideStance.stDevValue, analysis.frontSideStance.deviationPointsRight)}}%">
                        <span>{{analysis.frontSideStance.rawValueRight}}</span>
                        <span>R</span>
                      </div>
                      <div class="cs_bpar-mark cs-ml text-sm cs_min_gradient_label">10</div>
                      <div class="cs_bpar-mark cs-ml text-sm cs_max_gradient_label">60</div>
                    </div>
                  </div>
                  <p class="cs_pbar_description">
                    Front side stance is the percentage of stance phase that happens in front of your center of mass. Higher front side stance can indicate additional braking and slowing.
                  </p>
                </div>
                <!--  -->
                <div class="cs_pbar-wrapper ">
                  <div class="cs_pbar-item">
                    <div class="cs_pbar-val">
                      <h3 class="cs_pbar-lable">
                        Duty Factor
                      </h3>
                    </div>
                    <div class="cs_pbar-line" style="background: {{generateLinearGradient(10, 60, analysis.dutyFactor.avgValue, analysis.dutyFactor.stDevValue)}}">
                      <div class="cs_bpar-mark cs-ml" style="left:{{getGradientPosition(10, 60, analysis.dutyFactor.avgValue, analysis.dutyFactor.stDevValue, analysis.dutyFactor.deviationPointsLeft)}}%">
                        <span>{{analysis.dutyFactor.rawValueLeft}}</span>
                        <span>L</span>
                      </div>
                      <div class="cs_bpar-mark cs-mr" style="left:{{getGradientPosition(10, 60, analysis.dutyFactor.avgValue, analysis.dutyFactor.stDevValue, analysis.dutyFactor.deviationPointsRight)}}%">
                        <span>{{analysis.dutyFactor.rawValueRight}}</span>
                        <span>R</span>
                      </div>
                      <div class="cs_bpar-mark cs-ml text-sm cs_min_gradient_label">10</div>
                      <div class="cs_bpar-mark cs-ml text-sm cs_max_gradient_label">60</div>
                    </div>
                  </div>
                  <p class="cs_pbar_description">
                    Duty factor is the percentage of time spent on the ground (stance) versus the percentage of time spent in the air (swing). A lower value is desirable and it is beneficial to have similar duty cycle values across different speeds.
                  </p>
                </div>
                <!--  -->
                <div class="cs_pbar-wrapper ">
                  <div class="cs_pbar-item">
                    <div class="cs_pbar-val">
                      <h3 class="cs_pbar-lable">
                        Leg Stiffness
                      </h3>
                    </div>
                    <div class="cs_pbar-line" style="background: {{generateLinearGradient(5, 30, analysis.legStiffness.avgValue, analysis.legStiffness.stDevValue)}}">
                      <div class="cs_bpar-mark cs-ml" style="left:{{getGradientPosition(5, 30, analysis.legStiffness.avgValue, analysis.legStiffness.stDevValue, analysis.legStiffness.deviationPointsLeft)}}%">
                        <span>{{analysis.legStiffness.rawValueLeft}}</span>
                        <span>L</span>
                      </div>
                      <div class="cs_bpar-mark cs-mr" style="left:{{getGradientPosition(5, 30, analysis.legStiffness.avgValue, analysis.legStiffness.stDevValue, analysis.legStiffness.deviationPointsRight)}}%">
                        <span>{{analysis.legStiffness.rawValueRight}}</span>
                        <span>R</span>
                      </div>
                      <div class="cs_bpar-mark cs-ml text-sm cs_min_gradient_label">5</div>
                      <div class="cs_bpar-mark cs-ml text-sm cs_max_gradient_label">30</div>
                    </div>
                  </div>
                  <p class="cs_pbar_description">
                    Leg stiffness is a measure of how “springy” your leg is while running. Higher stiffness means that your body goes through less motion and lower stiffness means your body goes through more motion.
                    From a performance standpoint, higher stiffness can mean improved performance.
                    Asymmetrical stiffness may indicate past or future injury.
                  </p>
                </div>
                <!--  -->
              </div>


              <hr class="cs_page-break" />
              <!-- page 3 -->
              <div class="card card-body">

                <h3 class="text-center factor_section">INITIAL CONTACT</h3>
                <div class="cs_separator_gray"></div>
                <!--  -->
                <div class="cs_pbar-wrapper ">
                  <div class="cs_pbar-item">
                    <div class="cs_pbar-val">
                      <h3 class="cs_pbar-lable">
                        Tibial Inclination
                      </h3>
                    </div>
                    <div class="cs_pbar-line" style="background: {{generateLinearGradient(-10, 10, analysis.tibialInclination.avgValue, analysis.tibialInclination.stDevValue)}}">
                      <div class="cs_bpar-mark cs-ml" style="left:{{getGradientPosition(-10, 10, analysis.tibialInclination.avgValue, analysis.tibialInclination.stDevValue, analysis.tibialInclination.deviationPointsLeft)}}%">
                        <span>{{analysis.tibialInclination.rawValueLeft}}</span>
                        <span>L</span>
                      </div>
                      <div class="cs_bpar-mark cs-mr" style="left:{{getGradientPosition(-10, 10, analysis.tibialInclination.avgValue, analysis.tibialInclination.stDevValue, analysis.tibialInclination.deviationPointsRight)}}%">
                        <span>{{analysis.tibialInclination.rawValueRight}}</span>
                        <span>R</span>
                      </div>
                      <div class="cs_bpar-mark cs-ml text-sm cs_min_gradient_label">-10</div>
                      <div class="cs_bpar-mark cs-ml text-sm cs_max_gradient_label">10</div>
                    </div>
                  </div>
                  <div class="cs_bpar-mark-left">Extension (º)</div>
                  <div class="cs_bpar-mark-right">Flexion (º)</div>
                  <p class="cs_pbar_description after_annotation">
                    Tibial inclination is the angle of your shin bone in relationship to the ground.
                  </p>
                </div>
                <!--  -->
                <div class="cs_pbar-wrapper ">
                  <div class="cs_pbar-item">
                    <div class="cs_pbar-val">
                      <h3 class="cs_pbar-lable">
                        Foot Inclination
                      </h3>
                    </div>
                    <div class="cs_pbar-line" style="background: {{generateLinearGradient(-40, 40, analysis.footInclination.avgValue, analysis.footInclination.stDevValue)}}">
                      <div class="cs_bpar-mark cs-ml" style="left:{{getGradientPosition(-40, 40, analysis.footInclination.avgValue, analysis.footInclination.stDevValue, analysis.footInclination.deviationPointsLeft)}}%">
                        <span>{{analysis.footInclination.rawValueLeft}}</span>
                        <span>L</span>
                      </div>
                      <div class="cs_bpar-mark cs-mr" style="left:{{getGradientPosition(-40, 40, analysis.footInclination.avgValue, analysis.footInclination.stDevValue, analysis.footInclination.deviationPointsRight)}}%">
                        <span>{{analysis.footInclination.rawValueRight}}</span>
                        <span>R</span>
                      </div>
                      <div class="cs_bpar-mark cs-ml text-sm cs_min_gradient_label">-40</div>
                      <div class="cs_bpar-mark cs-ml text-sm cs_max_gradient_label">40</div>
                    </div>
                  </div>
                  <div class="cs_bpar-mark-left">Dorsiflexion (º)</div>
                  <div class="cs_bpar-mark-right">Plantarflexion (º)</div>
                  <p class="cs_pbar_description after_annotation">
                    Foot inclination is the angle of your foot in relationship to the ground.
                  </p>
                </div>
                <!--  -->
                <div class="cs_pbar-wrapper ">
                  <div class="cs_pbar-item">
                    <div class="cs_pbar-val">
                      <h3 class="cs_pbar-lable">
                        Strike from COM
                      </h3>
                    </div>
                    <div class="cs_pbar-line" style="background: {{generateLinearGradient(15, 45, analysis.strikeCOM.avgValue, analysis.strikeCOM.stDevValue)}}">
                      <div class="cs_bpar-mark cs-ml" style="left:{{getGradientPosition(15, 45, analysis.strikeCOM.avgValue, analysis.strikeCOM.stDevValue, analysis.strikeCOM.deviationPointsLeft)}}%">
                        <span>{{analysis.strikeCOM.rawValueLeft}}</span>
                        <span>L</span>
                      </div>
                      <div class="cs_bpar-mark cs-mr" style="left:{{getGradientPosition(15, 45, analysis.strikeCOM.avgValue, analysis.strikeCOM.stDevValue, analysis.strikeCOM.deviationPointsRight)}}%">
                        <span>{{analysis.strikeCOM.rawValueRight}}</span>
                        <span>R</span>
                      </div>
                      <div class="cs_bpar-mark cs-ml text-sm cs_min_gradient_label">15</div>
                      <div class="cs_bpar-mark cs-ml text-sm cs_max_gradient_label">45</div>
                    </div>
                  </div>
                  <p class="cs_pbar_description">
                    Strike from center of mass (COM) is the distance from your center of mass to where your foot hits the ground. It is a measure that is related to the forces going through your lower body.
                  </p>
                </div>
                <!--  -->
                <div class="cs_pbar-wrapper ">
                  <div class="cs_pbar-item">
                    <div class="cs_pbar-val">
                      <h3 class="cs_pbar-lable">
                        Crossover
                      </h3>
                    </div>
                    <div class="cs_pbar-line" style="background: {{generateLinearGradient(-15, 25, analysis.crossover.avgValue, analysis.crossover.stDevValue)}}">
                      <div class="cs_bpar-mark cs-ml" style="left:{{getGradientPosition(-15, 25, analysis.crossover.avgValue, analysis.crossover.stDevValue, analysis.crossover.deviationPointsLeft)}}%">
                        <span>{{analysis.crossover.rawValueLeft}}</span>
                        <span>L</span>
                      </div>
                      <div class="cs_bpar-mark cs-mr" style="left:{{getGradientPosition(-15, 25, analysis.crossover.avgValue, analysis.crossover.stDevValue, analysis.crossover.deviationPointsRight)}}%">
                        <span>{{analysis.crossover.rawValueRight}}</span>
                        <span>R</span>
                      </div>
                      <div class="cs_bpar-mark cs-ml text-sm cs_min_gradient_label">-15</div>
                      <div class="cs_bpar-mark cs-ml text-sm cs_max_gradient_label">25</div>
                    </div>
                  </div>
                  <div class="cs_bpar-mark-left">Adduction (cm)</div>
                  <div class="cs_bpar-mark-right">Abduction (cm)</div>
                  <p class="cs_pbar_description after_annotation">
                    Crossover describes the position of the foot at initial contact relative to the midline of your body.
                  </p>
                </div>
                <!--  -->
                <div class="cs_pbar-wrapper" style="padding-top:0px;">
                  <div class="cs_pbar-item min_height_3">
                    <div class="cs_pbar-val">
                      <h3 class="cs_pbar-lable">
                        Foot Strike
                      </h3>
                    </div>
                    <div class="cs_pbar-lin foot_strike_section">
                      <div style="margin-right: 6em;">
                        <span class="foot_strike_label">Left:</span> <span class="foot_strike_value">{{analysis.footStrikeLeft | enumString: footStrikeEnum}}</span>
                      </div>
                      <div>
                        <span class="foot_strike_label">Right:</span> <span class="foot_strike_value">{{analysis.footStrikeRight | enumString: footStrikeEnum}}</span>
                      </div>
                    </div>
                  </div>
                  <p class="cs_pbar_description">
                    Foot strike describes the portion of the foot which hits the ground at initial contact. Rearfoot strike means that you land on your heel. Non-rearfoot strike means that you land on the middle or front of your foot.
                  </p>
                </div>
              </div>


              <hr class="cs_page-break" />
              <!-- page 4 -->
              <div class="card card-body">

                <h3 class="text-center factor_section">STANCE</h3>
                <div class="cs_separator_gray"></div>
                <!--  -->
                <div class="cs_pbar-wrapper cs_label-to-center">
                  <div class="cs_pbar-item">
                    <div class="cs_pbar-val">
                      <h3 class="cs_pbar-lable">
                        Peak Ankle
                        Dorsiflexion
                      </h3>
                    </div>
                    <div class="cs_pbar-line" style="background: {{generateLinearGradient(-40, 20, analysis.peakAnkleDorsiflexion.avgValue, analysis.peakAnkleDorsiflexion.stDevValue)}}">
                      <div class="cs_bpar-mark cs-ml" style="left:{{getGradientPosition(-40, 20, analysis.peakAnkleDorsiflexion.avgValue, analysis.peakAnkleDorsiflexion.stDevValue, analysis.peakAnkleDorsiflexion.deviationPointsLeft)}}%">
                        <span>{{analysis.peakAnkleDorsiflexion.rawValueLeft}}</span>
                        <span>L</span>
                      </div>
                      <div class="cs_bpar-mark cs-mr" style="left:{{getGradientPosition(-40, 20, analysis.peakAnkleDorsiflexion.avgValue, analysis.peakAnkleDorsiflexion.stDevValue, analysis.peakAnkleDorsiflexion.deviationPointsRight)}}%">
                        <span>{{analysis.peakAnkleDorsiflexion.rawValueRight}}</span>
                        <span>R</span>
                      </div>
                      <div class="cs_bpar-mark cs-ml text-sm cs_min_gradient_label">-40</div>
                      <div class="cs_bpar-mark cs-ml text-sm cs_max_gradient_label">20</div>
                    </div>
                  </div>
                  <div class="cs_bpar-mark-left">Dorsiflexion (º)</div>
                  <div class="cs_bpar-mark-right">Plantarflexion (º)</div>
                  <p class="cs_pbar_description after_annotation">
                    Peak ankle dorsiflexion is the amount of motion occuring at the ankle during stance phase that contributes to force absorption.
                  </p>
                </div>
                <!--  -->
                <div class="cs_pbar-wrapper cs_label--center">
                  <div class="cs_pbar-item">
                    <div class="cs_pbar-val">
                      <h3 class="cs_pbar-lable">
                        Peak Ankle Pronation
                      </h3>
                    </div>
                    <div class="cs_pbar-line" style="background: {{generateLinearGradient(-5, 15, analysis.peakAnklePronation.avgValue, analysis.peakAnklePronation.stDevValue)}}">
                      <div class="cs_bpar-mark cs-ml" style="left:{{getGradientPosition(-5, 15, analysis.peakAnklePronation.avgValue, analysis.peakAnklePronation.stDevValue, analysis.peakAnklePronation.deviationPointsLeft)}}%">
                        <span>{{analysis.peakAnklePronation.rawValueLeft}}</span>
                        <span>L</span>
                      </div>
                      <div class="cs_bpar-mark cs-mr" style="left:{{getGradientPosition(-5, 15, analysis.peakAnklePronation.avgValue, analysis.peakAnklePronation.stDevValue, analysis.peakAnklePronation.deviationPointsRight)}}%">
                        <span>{{analysis.peakAnklePronation.rawValueRight}}</span>
                        <span>R</span>
                      </div>
                      <div class="cs_bpar-mark cs-ml text-sm cs_min_gradient_label">-5</div>
                      <div class="cs_bpar-mark cs-ml text-sm cs_max_gradient_label">15</div>
                    </div>
                  </div>
                  <div class="cs_bpar-mark-left">Supination (º)</div>
                  <div class="cs_bpar-mark-right">Pronation (º)</div>
                  <p class="cs_pbar_description after_annotation">
                    Peak ankle pronation is the maximum inward rolling motion of the foot during stance phase.
                    Pronation is a normal part of running. When we pronate, it allows our foot to come in contact with the ground and absorb forces.
                  </p>
                </div>
                <!--  -->
                <!--  -->
                <div class="cs_pbar-wrapper ">
                  <div class="cs_pbar-item">
                    <div class="cs_pbar-val">
                      <h3 class="cs_pbar-lable">
                        Peak Knee Flexion
                      </h3>
                    </div>
                    <div class="cs_pbar-line" style="background: {{generateLinearGradient(0, 60, analysis.peakKneeFlexion.avgValue, analysis.peakKneeFlexion.stDevValue)}}">
                      <div class="cs_bpar-mark cs-ml" style="left:{{getGradientPosition(0, 60, analysis.peakKneeFlexion.avgValue, analysis.peakKneeFlexion.stDevValue, analysis.peakKneeFlexion.deviationPointsLeft)}}%">
                        <span>{{analysis.peakKneeFlexion.rawValueLeft}}</span>
                        <span>L</span>
                      </div>
                      <div class="cs_bpar-mark cs-mr" style="left:{{getGradientPosition(0, 60, analysis.peakKneeFlexion.avgValue, analysis.peakKneeFlexion.stDevValue, analysis.peakKneeFlexion.deviationPointsRight)}}%">
                        <span>{{analysis.peakKneeFlexion.rawValueRight}}</span>
                        <span>R</span>
                      </div>
                      <div class="cs_bpar-mark cs-ml text-sm cs_min_gradient_label">0</div>
                      <div class="cs_bpar-mark cs-ml text-sm cs_max_gradient_label">60</div>
                    </div>
                  </div>
                  <p class="cs_pbar_description">
                    Peak knee flexion is the maximum bending of the knee during stance phase, and is another measure to gauge how much your body is sinking into the ground.
                  </p>
                </div>
                <!--  -->
                <div class="cs_pbar-wrapper ">
                  <div class="cs_pbar-item">
                    <div class="cs_pbar-val">
                      <h3 class="cs_pbar-lable">
                        Peak Hip Adduction
                      </h3>
                    </div>
                    <div class="cs_pbar-line" style="background: {{generateLinearGradient(-20, 20, analysis.peakHipAdduction.avgValue, analysis.peakHipAdduction.stDevValue)}}">
                      <div class="cs_bpar-mark cs-ml" style="left:{{getGradientPosition(-20, 20, analysis.peakHipAdduction.avgValue, analysis.peakHipAdduction.stDevValue, analysis.peakHipAdduction.deviationPointsLeft)}}%">
                        <span>{{analysis.peakHipAdduction.rawValueLeft}}</span>
                        <span>L</span>
                      </div>
                      <div class="cs_bpar-mark cs-mr" style="left:{{getGradientPosition(-20, 20, analysis.peakHipAdduction.avgValue, analysis.peakHipAdduction.stDevValue, analysis.peakHipAdduction.deviationPointsRight)}}%">
                        <span>{{analysis.peakHipAdduction.rawValueRight}}</span>
                        <span>R</span>
                      </div>
                      <div class="cs_bpar-mark cs-ml text-sm cs_min_gradient_label">-20</div>
                      <div class="cs_bpar-mark cs-ml text-sm cs_max_gradient_label">20</div>
                    </div>
                  </div>
                  <div class="cs_bpar-mark-left">Adduction (º)</div>
                  <div class="cs_bpar-mark-right">Abduction (º)</div>
                  <p class="cs_pbar_description after_annotation">
                    Peak hip adduction is the maximum hip movement toward the midline of the body and the femur bones get closer together.
                    This is an important part of absorbing forces, but excessive motion can put increased strain on the body.
                  </p>
                </div>
                <!--  -->
                <div class="cs_pbar-wrapper ">
                  <div class="cs_pbar-item">
                    <div class="cs_pbar-val">
                      <h3 class="cs_pbar-lable">
                        Peak Hip IR
                      </h3>
                    </div>
                    <div class="cs_pbar-line" style="background: {{generateLinearGradient(-15, 20, analysis.peakHipIr.avgValue, analysis.peakHipIr.stDevValue)}}">
                      <div class="cs_bpar-mark cs-ml" style="left:{{getGradientPosition(-15, 20, analysis.peakHipIr.avgValue, analysis.peakHipIr.stDevValue, analysis.peakHipIr.deviationPointsLeft)}}%">
                        <span>{{analysis.peakHipIr.rawValueLeft}}</span>
                        <span>L</span>
                      </div>
                      <div class="cs_bpar-mark cs-mr" style="left:{{getGradientPosition(-15, 20, analysis.peakHipIr.avgValue, analysis.peakHipIr.stDevValue, analysis.peakHipIr.deviationPointsRight)}}%">
                        <span>{{analysis.peakHipIr.rawValueRight}}</span>
                        <span>R</span>
                      </div>
                      <div class="cs_bpar-mark cs-ml text-sm cs_min_gradient_label">-15</div>
                      <div class="cs_bpar-mark cs-ml text-sm cs_max_gradient_label">20</div>
                    </div>
                  </div>
                  <div class="cs_bpar-mark-left">Internal Rotation (º)</div>
                  <div class="cs_bpar-mark-right">External Rotation (º)</div>
                  <p class="cs_pbar_description after_annotation">
                    Peak hip internal rotation (IR) is the maximum amount of hip rotation inwards toward the midline of the body.
                    This is an important part of absorbing forces, but excessive motion can put increased strain on the body.
                  </p>
                </div>
                <!--  -->
                <div class="cs_pbar-wrapper cs_label-to-center">
                  <div class="cs_pbar-item">
                    <div class="cs_pbar-val">
                      <h3 class="cs_pbar-lable">
                        Peak Contralateral
                        Pelvic Drop
                      </h3>
                    </div>
                    <div class="cs_pbar-line" style="background: {{generateLinearGradient(-15, 15, analysis.peakContralateralPelvicDrop.avgValue, analysis.peakContralateralPelvicDrop.stDevValue)}}">
                      <div class="cs_bpar-mark cs-ml" style="left:{{getGradientPosition(-15, 15, analysis.peakContralateralPelvicDrop.avgValue, analysis.peakContralateralPelvicDrop.stDevValue, -analysis.peakContralateralPelvicDrop.deviationPointsLeft)}}%">
                        <span>{{analysis.peakContralateralPelvicDrop.rawValueLeft}}</span>
                        <span>L</span>
                      </div>
                      <div class="cs_bpar-mark cs-mr" style="left:{{getGradientPosition(-15, 15, analysis.peakContralateralPelvicDrop.avgValue, analysis.peakContralateralPelvicDrop.stDevValue, -analysis.peakContralateralPelvicDrop.deviationPointsRight)}}%">
                        <span>{{analysis.peakContralateralPelvicDrop.rawValueRight}}</span>
                        <span>R</span>
                      </div>
                      <div class="cs_bpar-mark cs-ml text-sm cs_min_gradient_label">-15</div>
                      <div class="cs_bpar-mark cs-ml text-sm cs_max_gradient_label">15</div>
                    </div>
                  </div>
                  <div class="cs_bpar-mark-left">Hip Drop (º)</div>
                  <div class="cs_bpar-mark-right">Hip Hike (º)</div>
                  <p class="cs_pbar_description after_annotation">
                    Peak contralateral pelvic drop is the lateral pelvic angle during stance phase, and is often seen in association with excessive hip, knee, and ankle collapse.
                    It is often debated whether this excessive collapse is generated from the bottom down (i.e. the hip drop causes changes in the joints below) or from the bottom up (i.e. the lower joint weakness causes changes in the joints above)
                  </p>
                </div>
                <!--  -->
                <div class="cs_pbar-wrapper cs_label-to-center">
                  <div class="cs_pbar-item">
                    <div class="cs_pbar-val">
                      <h3 class="cs_pbar-lable">
                        Forward Lean Angle at Mid-Stance
                      </h3>
                    </div>
                    <div class="cs_pbar-line" style="background: {{generateLinearGradient(0, 12, analysis.forwardLeanAngle.avgValue, analysis.forwardLeanAngle.stDevValue)}}">
                      <div class="cs_bpar-mark cs-ml" style="left:{{getGradientPosition(0, 12, analysis.forwardLeanAngle.avgValue, analysis.forwardLeanAngle.stDevValue, analysis.forwardLeanAngle.deviationPointsLeft)}}%">
                        <span>{{analysis.forwardLeanAngle.rawValueLeft}}</span>
                        <span>L</span>
                      </div>
                      <div class="cs_bpar-mark cs-mr" style="left:{{getGradientPosition(0, 12, analysis.forwardLeanAngle.avgValue, analysis.forwardLeanAngle.stDevValue, analysis.forwardLeanAngle.deviationPointsRight)}}%">
                        <span>{{analysis.forwardLeanAngle.rawValueRight}}</span>
                        <span>R</span>
                      </div>
                      <div class="cs_bpar-mark cs-ml text-sm cs_min_gradient_label">0</div>
                      <div class="cs_bpar-mark cs-ml text-sm cs_max_gradient_label">12</div>
                    </div>
                  </div>
                  <p class="cs_pbar_description">
                    Forward lean angle measures how far forward or backwards you lean during running.
                  </p>
                </div>
              </div>

              <!--<hr class="cs_page-break" />-->
              <!-- page 5 -->
              <div class="card card-body">
                <h3 class="text-center factor_section">TERMINAL STANCE</h3>
                <div class="cs_separator_gray"></div>
                <div class="cs_pbar-wrapper">
                  <div class="cs_pbar-item">
                    <div class="cs_pbar-val">
                      <h3 class="cs_pbar-lable">
                        Hip Extension
                      </h3>
                    </div>
                    <div class="cs_pbar-line" style="background: {{generateLinearGradient(-30, 0, analysis.hipExtension.avgValue, analysis.hipExtension.stDevValue)}}">
                      <div class="cs_bpar-mark cs-ml" style="left:{{getGradientPosition(-30, 0, analysis.hipExtension.avgValue, analysis.hipExtension.stDevValue, analysis.hipExtension.deviationPointsLeft)}}%">
                        <span>{{analysis.hipExtension.rawValueLeft}}</span>
                        <span>L</span>
                      </div>
                      <div class="cs_bpar-mark cs-mr" style="left:{{getGradientPosition(-30, 0, analysis.hipExtension.avgValue, analysis.hipExtension.stDevValue, analysis.hipExtension.deviationPointsRight)}}%">
                        <span>{{analysis.hipExtension.rawValueRight}}</span>
                        <span>R</span>
                      </div>
                      <div class="cs_bpar-mark cs-ml text-sm cs_min_gradient_label">-30</div>
                      <div class="cs_bpar-mark cs-ml text-sm cs_max_gradient_label">0</div>
                    </div>
                  </div>
                  <div class="cs_bpar-mark-left">Extension (º)</div>
                  <div class="cs_bpar-mark-right">Flexion (º)</div>
                  <p class="cs_pbar_description after_annotation">
                    Hip extension is the straightening of the hip at the end of stance phase as the body moves forward.
                  </p>
                </div>
                <!--  -->
                <div class="cs_pbar-wrapper ">
                  <div class="cs_pbar-item">
                    <div class="cs_pbar-val">
                      <h3 class="cs_pbar-lable">
                        Ankle Supination
                      </h3>
                    </div>
                    <div class="cs_pbar-line" style="background: {{generateLinearGradient(-15, 15, analysis.ankleSupination.avgValue, analysis.ankleSupination.stDevValue)}}">
                      <div class="cs_bpar-mark cs-ml" style="left:{{getGradientPosition(-15, 15, analysis.ankleSupination.avgValue, analysis.ankleSupination.stDevValue, analysis.ankleSupination.deviationPointsLeft)}}%">
                        <span>{{analysis.ankleSupination.rawValueLeft}}</span>
                        <span>L</span>
                      </div>
                      <div class="cs_bpar-mark cs-mr" style="left:{{getGradientPosition(-15, 15, analysis.ankleSupination.avgValue, analysis.ankleSupination.stDevValue, analysis.ankleSupination.deviationPointsRight)}}%">
                        <span>{{analysis.ankleSupination.rawValueRight}}</span>
                        <span>R</span>
                      </div>
                      <div class="cs_bpar-mark cs-ml text-sm cs_min_gradient_label">-15</div>
                      <div class="cs_bpar-mark cs-ml text-sm cs_max_gradient_label">15</div>
                    </div>
                  </div>
                  <div class="cs_bpar-mark-left">Supination (º)</div>
                  <div class="cs_bpar-mark-right">Pronation (º)</div>
                  <p class="cs_pbar_description after_annotation">
                    Ankle supination occurs when your body pushes off to create a rigid lever at the foot.
                  </p>
                </div>
                <!--  -->

                <h3 class="text-center factor_section">SWING</h3>
                <div class="cs_separator_gray"></div>
                <div class="cs_pbar-wrapper ">
                  <div class="cs_pbar-item">
                    <div class="cs_pbar-val">
                      <h3 class="cs_pbar-lable">
                        Peak Hip Flexion
                      </h3>
                    </div>
                    <div class="cs_pbar-line" style="background: {{generateLinearGradient(0, 70, analysis.peakHipFlexion.avgValue, analysis.peakHipFlexion.stDevValue)}}">
                      <div class="cs_bpar-mark cs-ml" style="left:{{getGradientPosition(0, 70, analysis.peakHipFlexion.avgValue, analysis.peakHipFlexion.stDevValue, analysis.peakHipFlexion.deviationPointsLeft)}}%">
                        <span>{{analysis.peakHipFlexion.rawValueLeft}}</span>
                        <span>L</span>
                      </div>
                      <div class="cs_bpar-mark cs-mr" style="left:{{getGradientPosition(0, 70, analysis.peakHipFlexion.avgValue, analysis.peakHipFlexion.stDevValue, analysis.peakHipFlexion.deviationPointsRight)}}%">
                        <span>{{analysis.peakHipFlexion.rawValueRight}}</span>
                        <span>R</span>
                      </div>
                      <div class="cs_bpar-mark cs-ml text-sm cs_min_gradient_label">0</div>
                      <div class="cs_bpar-mark cs-ml text-sm cs_max_gradient_label">70</div>
                    </div>
                  </div>
                  <p class="cs_pbar_description">
                    Peak hip flexion during the swing phase has been linked to the rate at which the foot accelerates towards the ground at initial contact.
                    If you are limited in hip flexion, it may change how you absorb forces on the ground.
                  </p>
                </div>
              </div>

              <hr class="cs_page-break" />
              <!-- page Diagrams -->
              <div class="card card-body">
                <!--<div class="cs_space"></div>-->
                <div class="cs_short-box">
                  <h1 class="text-center">Biomechanics Details</h1>
                  <p class="text-center">
                    Below are graphical representations of how each joint moves during the running cycle. The gray area represents the normative values.
                    The left (red) and right (blue) lines represent the average of all the steps you took while running.
                    Click on a diagram to see more details.
                  </p>
                </div>
                <div class="cs_chart-grid-wrapper">
                  <!--<div *ngFor="let dgDiagrams of groupedDiagrams | keyvalue" class="cs_chart-grid">
    <div class="cs_chart-item">
      <h3 class="cs_chart-section">{{dgDiagrams.key}}</h3>
    </div>
    <div *ngFor="let diagram of dgDiagrams.value" class="cs_chart-item" (click)="showDiagram(diagram)">
      <h3>{{diagram.title}}</h3>
      <img src="{{diagram.resizedUrl}}" />
    </div>
  </div>-->

                  <div class="cs_chart-grid">
                    <div class="cs_chart-item">
                      <h3 class="cs_chart-section">Pelvis</h3>
                    </div>
                    <div class="cs_chart-item" *ngIf="getDiagram('Pelvis', 'Tilt') as diagram" (click)="showDiagram(diagram)">
                      <h3>Tilt</h3>
                      <img [src]="diagram.resizedUrl" />
                    </div>
                    <div class="cs_chart-item" *ngIf="getDiagram('Pelvis', 'Obliquity') as diagram" (click)="showDiagram(diagram)">
                      <h3>Obliquity</h3>
                      <img [src]="diagram.resizedUrl" />
                    </div>
                    <div class="cs_chart-item" *ngIf="getDiagram('Pelvis', 'Rotation') as diagram" (click)="showDiagram(diagram)">
                      <h3>Rotation</h3>
                      <img [src]="diagram.resizedUrl" />
                    </div>

                    <div class="cs_chart-item">
                      <h3 class="cs_chart-section">Hips</h3>
                    </div>
                    <div class="cs_chart-item" *ngIf="getDiagram('Hips', 'Flexion/Extension') as diagram" (click)="showDiagram(diagram)">
                      <h3>Flexion/Extension</h3>
                      <img [src]="diagram.resizedUrl" />
                    </div>
                    <div class="cs_chart-item" *ngIf="getDiagram('Hips', 'Abduction/Adduction') as diagram" (click)="showDiagram(diagram)">
                      <h3>Abduction/Adduction</h3>
                      <img [src]="diagram.resizedUrl" />
                    </div>
                    <div class="cs_chart-item" *ngIf="getDiagram('Hips', 'Rotation') as diagram" (click)="showDiagram(diagram)">
                      <h3>Rotation</h3>
                      <img [src]="diagram.resizedUrl" />
                    </div>

                    <div class="cs_chart-item">
                      <h3 class="cs_chart-section">Knees</h3>
                    </div>
                    <div class="cs_chart-item" *ngIf="getDiagram('Knees', 'Flexion/Extension') as diagram" (click)="showDiagram(diagram)">
                      <h3>Flexion/Extension</h3>
                      <img [src]="diagram.resizedUrl" />
                    </div>
                    <div class="cs_chart-item" *ngIf="getDiagram('Knees', 'Varus/Valgus') as diagram" (click)="showDiagram(diagram)">
                      <h3>Varus/Valgus</h3>
                      <img [src]="diagram.resizedUrl" />
                    </div>
                    <div class="cs_chart-item" *ngIf="getDiagram('Knees', 'Rotation') as diagram" (click)="showDiagram(diagram)">
                      <h3>Rotation</h3>
                      <img [src]="diagram.resizedUrl" />
                    </div>

                    <div class="cs_chart-item">
                      <h3 class="cs_chart-section">Ankles</h3>
                    </div>
                    <div class="cs_chart-item" *ngIf="getDiagram('Ankles', 'Dorsal/Plantar Flexion') as diagram" (click)="showDiagram(diagram)">
                      <h3>Dorsal/Plantar Flexion</h3>
                      <img [src]="diagram.resizedUrl" />
                    </div>
                    <div class="cs_chart-item" *ngIf="getDiagram('Ankles', 'Supination/Pronation') as diagram" (click)="showDiagram(diagram)">
                      <h3>Supination/Pronation</h3>
                      <img [src]="diagram.resizedUrl" />
                    </div>
                    <div class="cs_chart-item" *ngIf="getDiagram('Ankles', 'Rotation') as diagram" (click)="showDiagram(diagram)">
                      <h3>Rotation</h3>
                      <img [src]="diagram.resizedUrl" />
                    </div>
                  </div>
                  <div class="cs_chart-grid-2col">
                    <div class="cs_chart-item-big">
                      <h3 class="cs_chart-section">Combined</h3>
                    </div>
                    <div class="cs_chart-item-big cs_chart-item-big-first" *ngIf="getDiagram('Combined', 'Hip-Ankle') as diagram" (click)="showDiagram(diagram)">
                      <h3>Hip-Ankle</h3>
                      <img [src]="diagram.resizedUrl" />
                    </div>
                    <div class="cs_chart-item-big cs_chart-item-big-second" *ngIf="getDiagram('Combined', 'Knee-Ankle') as diagram" (click)="showDiagram(diagram)">
                      <h3>Knee-Ankle</h3>
                      <img [src]="diagram.resizedUrl" />
                    </div>
                   </div>
                  </div>
                  <div class="cs_notes cs_mt1">
                    <div class="cs_notes-label"></div>
                    <div class="cs_notes-content">
                      <!-- Lorem ipsum dolor sit amet. -->
                    </div>
                  </div>
                </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
